import { useIntl } from '@capsicum/common';
import { Button, InfoCard, Text } from '@capsicum/common-web';
import { type V2FTMigrationScreenProps } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

import { useV2FTMigrationUpgradeScreen } from '../../hooks';
import { FanTokenBreakdownCard } from '../fan-token-breakdown-card/FanTokenBreakdownCard';

import { V2FTMigrationScreenContainer } from './V2FTMigrationScreenContainer';

export const V2FTMigrationUpgradeScreen = ({ changeScreen, tokens }: V2FTMigrationScreenProps) => {
	const { $t } = useIntl();

	const {
		altCurrencyFee,
		defaultCurrencyFee,
		hasErrored,
		isLoading: isMigrationUpgradeScreenLoading,
		isNetworkFeeLoading,
		sendTransaction
	} = useV2FTMigrationUpgradeScreen({ changeScreen, tokens });

	return (
		<V2FTMigrationScreenContainer
			footer={
				<Button
					disabled={hasErrored}
					fullWidth
					isLoading={isMigrationUpgradeScreenLoading}
					testID="V2FTMigrationUpgradeScreen-migrate-button"
					text={$t('v2FTMigrationInitFlow.upgrade.actions.migrate')}
					onClick={sendTransaction}
				/>
			}
			title={$t('v2FTMigrationInitFlow.upgrade.title')}
			onBack={() => changeScreen('MODAL')}
		>
			<S.Content>
				<Text variant="title5">{$t('v2FTMigrationInitFlow.upgrade.subtitle')}</Text>

				<Text color="main.subtle" variant="text2">
					{$t('v2FTMigrationInitFlow.upgrade.description')}
				</Text>

				<FanTokenBreakdownCard tokens={tokens} />

				<InfoCard
					hasRibbon
					isLoading={isNetworkFeeLoading}
					isRightTextStrikethrough
					leftRibbonText={$t('v2FTMigrationInitFlow.upgrade.sections.networkFee.coverage')}
					mainRightText={defaultCurrencyFee}
					rightRibbonText={$t('v2FTMigrationInitFlow.upgrade.sections.networkFee.free')}
					secondaryRightText={altCurrencyFee}
					testID="V2FTMigrationFAQScreen-networkFee-card"
					title={$t('v2FTMigrationInitFlow.upgrade.sections.networkFee.title')}
					tooltipText={$t('v2FTMigrationInitFlow.upgrade.sections.networkFee.description')}
				/>
			</S.Content>
		</V2FTMigrationScreenContainer>
	);
};

namespace S {
	export const Content = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xsmall};
	`;
}
